<template>
    <!-- コンポーネント -->
    <div class="flex-box fl-between">
        <template v-if="this.getPage === 'app'">
          <objective-knob v-if="checkReadOnly || isComplete" :progress="getRate" @changeKnob="knobChange" :readOnly="checkReadOnly" :width="checkKnobSize" :height="checkKnobSize" ref="knob"></objective-knob>
          <objective-knob-edit v-else :progress="getRate" @changeKnob="knobChange" :readOnly="checkReadOnly" :width="checkKnobSize" :height="checkKnobSize" ref="knob"></objective-knob-edit>
        </template>
        <span :class="{ 'current-obj': this.objective }" class="objective-text">
          <read-more :targetId="this.getId" :text="content" :okrTree="this.getOkrTree" :addMore="this.addMoreFrag" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
            {{content}}
          </read-more>
        </span>
        <template v-if="this.getPage === 'report' || this.getPage === 'okrTree'">
          <objective-knob :progress="getRate" @changeKnob="knobChange" :readOnly="checkReadOnly" :width="checkKnobSize" :height="checkKnobSize" ref="knob"></objective-knob>
        </template>
    </div>
    <!-- コンポーネント -->
</template>

<script>
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'
import ObjectiveKnobEdit from '@/components/Okr/ObjectiveKnobEdit'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'

export default {
  name: 'Objective',
  props: {
    content: {
      type: String
    },
    progress: {
      type: String
    },
    setReadOnly: {
      type: String
    },
    isReadMore: {
      type: Boolean
    },
    components: {
      ReadMore
    },
    detailView: {
      type: Boolean
    },
    objective: {
      type: Boolean
    },
    isComplete: {
      type: Boolean,
      default: false
    },
    itemId: {
      type: String,
      default: 'id'
    },
    page: {
      type: String,
      default: 'app'
    },
    addMore: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    addMoreFrag () {
      return (this.addMore || this.detailView)
    },
    getRate: function () {
      return Number.parseInt(this.progress)
    },
    checkReadOnly () {
      if (this.setReadOnly === 'false') return true
      else return false
    },
    checkKnobSize () {
      if (this.setReadOnly === 'false' && this.getPage === 'app') return 65
      else if (this.setReadOnly === 'false' && (this.getPage === 'report' || this.getPage === 'okrTree')) return 40
      else return 80
    },
    getId () {
      return this.itemId
    },
    getPage () {
      return this.page
    },
    getOkrTree () {
      return this.getPage === 'okrTree'
    }
  },
  components: {
    ObjectiveKnob,
    ObjectiveKnobEdit,
    ReadMore
  },
  data () {
    return {
      knobValue: 100,
      propShowMore: false,
      propContentHeight: 0
    }
  },
  mounted: function () {
    // if (this.detailView === true) {
    //   let el = document.querySelector('.sub-column')
    //   let callEvent = this.$refs.readMore
    //   el.addEventListener('transitionend', function () {
    //     callEvent.checkTransition()
    //   })
    // }
  },
  updated: function () {
    this.$refs.knob.adjust(Number(this.progress))
  },
  methods: {
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      // console.log('in objective updateContentHeight::', value)
      this.propContentHeight = value
    },
    knobChange (value) {
      // console.log('--1', value)
      this.$emit('set-progress', value)
    },
    send () {
      this.knobValue = 255
      // console.log(this.knobValue)
    },
    back (value) {
      this.$refs.knob.back(value)
    },
    hideMoreShow: function (isMoreShow) {
      // console.log(isMoreShow)
      this.$refs('triggerReadMore', true, isMoreShow)
    }
  }
}
</script>
<style scoped>
.flex-box {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Okr/Objective.vue